import { formatDate, formatDateISO } from '@helpers/date';
import { imageUrl } from '@helpers/image';
import CtaLink from '@stories/Components/Buttons/CtaLink/CtaLink';
import * as React from 'react';
import { EventLocationType, getCategoryTitle, } from '../EventListingCard/EventListingCard';
import S from './PastEventListingCard.styles';
const PastEventListingCard = (props) => {
    return (React.createElement(S.Container, { "data-category": props.category },
        React.createElement(S.ImageWrapper, null,
            React.createElement(S.Img, { src: imageUrl(props.image, {}), alt: props.image.altText, loading: 'lazy' })),
        React.createElement(S.Category, null,
            React.createElement(S.CategoryTag, null, getCategoryTitle(props.category))),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.DateTypeWrapper, null,
                React.createElement("time", { dateTime: formatDateISO(props.date) }, formatDate(props.date, 'LLLL yyyy')),
                props.location && React.createElement("span", null, props.location)),
            React.createElement(S.Title, null, props.title),
            React.createElement(S.Info, { "data-type": "overview", dangerouslySetInnerHTML: { __html: props.overview } }),
            props.url && (React.createElement(CtaLink, { href: props.url }, props.location === EventLocationType.Webinar ? 'Watch Webinar' : 'Read Summary')),
            props.categoryTags && props.categoryTags.length > 0 ? (React.createElement(S.Info, { "data-type": "tags", dangerouslySetInnerHTML: { __html: props.categoryTags.join(' | ') } })) : null)));
};
export default PastEventListingCard;
